/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';

import { selectors as listSelectors } from '../../app/redux/ducks/lists/lists';

import Frequency from '../../models/Frequency';

function mapStateToProps(state, props) {
  return {
    currentFrequency: listSelectors.getFrequencyFromId(props.frequencyData.id, state),
  };
}

const FrequencyText = (props) => {
  const { frequencyData, currentFrequency } = props;

  const frequencyPhraseKeyData = Frequency.getPhraseData(currentFrequency, frequencyData);
  return <FormattedMessage {...frequencyPhraseKeyData} />;
}

export default connect(mapStateToProps)(FrequencyText);
